var map = {
	"./3m.png": "fe64",
	"./abb-logo.png": "0f89",
	"./baxter.png": "58cf",
	"./br.png": "c75f",
	"./cancer.png": "91e3",
	"./cemar.png": "7821",
	"./cesb.png": "b221",
	"./cptm.png": "fa82",
	"./eletropaulo.png": "c5eb",
	"./embraer.png": "757e",
	"./jonshon.png": "972a",
	"./kodak.png": "8623",
	"./laranjeirao.png": "e75c",
	"./marata.png": "143b",
	"./metodista.png": "be99",
	"./monotrilho.png": "78aa",
	"./monsanto.png": "5d9d",
	"./pentaplast.png": "6449",
	"./placo.png": "85d4",
	"./quaglia.png": "6f1c",
	"./ralo.png": "bb72",
	"./rohmrhas.png": "2fce",
	"./shell.png": "ea32",
	"./tivit.png": "d86e",
	"./votorantim.png": "2a3c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b2a";